import Default from "./SimpleExpander";
export * from "./SimpleExpander";

export default Default;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/SimpleExpander/index.ts